<template>
    <div class="stored_energy_manage">
        <div class="energy_left">
            <div class="energy_left_div">
                <div class="energy_left_title linear_font">{{ $t('roofManage.hj') }}</div>
                <div class="energy_left_cnt">
                    <div class="energy_left_cnt_item">
                        <img src="../../../assets/image/custom/env_icon1.png" />
                        <div class="left_cnt_right">
                            <div>
                                {{ $t('roofManage.ssfengsu') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ envData && envData.fs }}</i>m/s
                            </div>
                        </div>
                    </div>
                    <div class="energy_left_cnt_item">
                        <img src="../../../assets/image/custom/env_icon2.png" />
                        <div class="left_cnt_right">
                            <div>
                                {{ $t('roofManage.ssfengxiang') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ envData && envData.fx }}</i>
                            </div>
                        </div>
                    </div>
                    <div class="energy_left_cnt_item">
                        <img src="../../../assets/image/custom/env_icon3.png" />
                        <div class="left_cnt_right">
                            <div>
                                {{ $t('roofManage.sswendu') }} 
                            </div>
                            <div>
                                <i class="linear_font">{{ envData && envData.temperature }}</i>℃
                            </div>
                        </div>
                    </div>
                    <div class="energy_left_cnt_item">
                        <img src="../../../assets/image/custom/env_icon4.png" />
                        <div class="left_cnt_right">
                            <div>
                                {{ $t('roofManage.ssfuzhaodu') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ envData && envData.zfx | formatMoney }}</i>MJ/m²
                            </div>
                        </div>
                    </div>
                    <div class="energy_left_cnt_item">
                        <img src="../../../assets/image/custom/env_icon5.png" />
                        <div class="left_cnt_right">
                            <div>
                                {{ $t('roofManage.ljfuzhaodu') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ envData && envData.ljfzd | formatMoney }}</i>MJ/m²
                            </div>
                        </div>
                    </div>
                    <div class="energy_left_cnt_item">
                        <img src="../../../assets/image/custom/env_icon6.png" />
                        <div class="left_cnt_right">
                            <div>
                                {{ $t('roofManage.ssshidu') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ envData && envData.sd }}</i>%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="energy_left_div">
                <div class="energy_left_title linear_font">{{ $t('roofManage.wenshiduquxian') }}</div>
                <div class="energy_left_cnt">
                    <v-chart :auto-resize="true" :options="centerBar" ref="centerBar" theme="ovilia-green" />
                </div>
            </div>
            <div class="energy_left_div">
                <div class="energy_left_title linear_font">风速风向</div>
                <div class="energy_left_cnt">
                    <v-chart :auto-resize="true" :options="fengsuRadar" ref="fengsuRadar" theme="ovilia-green" />
                    <!-- <img v-if="language == 'zh-CN'" src="../../../assets/image/custom/energy_fengsu.png" style="height: 100%;margin-left: 50%; transform: translate(-50%, 0)" />
                    <img v-else src="../../../assets/image/custom/energy_fengsu_en.png" style="height: 100%;margin-left: 50%; transform: translate(-50%, 0)" /> -->
                </div>
            </div>
            <div class="energy_left_div">
                <div class="energy_left_title linear_font">{{ $t('roofManage.fuzhaoduquxian') }}</div>
                <div class="energy_left_cnt">
                    <v-chart auto-resize :options="areaLine" ref="chart" theme="ovilia-green" />
                </div>
            </div>
        </div>
        <div class="energy_right">
            <div class="energy_right_top_div">
                <div class="energy_right_top_title">
                    <img src="../../../assets/image/custom/energy_circle.png" style="width: 0.5rem;height: 0.5rem;" />
                    <div>{{ currentCf && currentCf.name }}</div>
                </div>
                <div class="energy_right_top_cnt" ref="scrollNbq">
                    <div class="top_cnt_item_wrapper">
                        <div @mouseenter="toggleColorTop(item, true)" @mouseleave="toggleColorTop(item, false)" v-for="item in nbqList" :key="item.point_id" @click="goBwgDetail(item)" :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_item blue_rec' : 'top_cnt_item grey_rec']">
                            <div class="top_cnt_title">
                                <!-- <img src="../../../assets/image/custom/energy_fac_red.png" style="height: 1.4rem;" /> -->
                                <img src="../../../assets/image/custom/energy_fac_blue.png" v-if="selectedNbq.nbq_id == item.point_id" style="height: 1.4rem;" />
                                <img src="../../../assets/image/custom/energy_fac_grey.png" v-else style="height: 1.4rem;" />
                                <div style="font-size: 0.6rem;">{{ item.point_name }}</div>
                            </div>
                            <div class="top_cnt_cnt">
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S1</div>
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S2</div>
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S3</div>
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S4</div>
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S5</div>
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S6</div>
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S7</div>
                                <div :class="[selectedNbq.nbq_id == item.point_id ? 'top_cnt_cnt_item blue_lit_rec' : 'top_cnt_cnt_item grey_lit_rec']">S8</div>
                            </div>
                        </div>
                        <!-- <div class="top_cnt_item grey_rec"></div>
                        <div class="top_cnt_item red_rec"></div> -->
                    </div>
                </div>
            </div>
            <div class="energy_right_center_div">
                <div class="center_pic_div">
                    <img src="../../../assets/image/custom/energy_center_pic.png"/>
                    <div v-for="(item, index) in cf_data"
                        :key="item.id"
                        :class="[currentCf && currentCf.id == item.id ? 'center_pic_name center_pic_name_selected' : 'center_pic_name center_pic_name_unselected']"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="clickCf(item)">
                        <div class="center_pic_name_nbq"><i class="linear_font">{{item.num}}</i>{{ $t('roofManage.tai') }}</div>
                        <div class="center_pic_name_detail">{{item.name}}</div>                   
                    </div>
                    <div v-for="(item, index) in nbq_data"
                        :key="item.nbq_id"
                        class="center_nbq"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @mouseenter="toggleColor(item, true)">
                        <div class="center_nbq_blue" v-if="selectedNbq.nbq_id == item.nbq_id" @mouseenter="toggleColor(item, true)" @mouseleave="toggleColor(item, false)"></div>
                        <div v-if="item.fault && item.fault == 1 && selectedNbq.nbq_id == item.nbq_id" class="nbq_fault">NB02</div>
                    </div>
                </div>
            </div>
            <div class="energy_right_bottom_div">
                <div class="energy_right_title">{{ $t('roofManage.run') }}</div>
                <div class="energy_right_bottom_cnt">
                    <div class="energy_right_cnt_item">
                        <img src="../../../assets/image/custom/elec_day.png" />
                        <div class="cnt_right">
                            <div>
                                {{ $t('roofManage.daypower') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ runData && runData.active_power_day | formatMoney }}</i>{{ runData && runData.active_power_day_unit }}
                            </div>
                        </div>
                    </div>
                    <div class="energy_right_cnt_item">
                        <img src="../../../assets/image/custom/elec_month.png" />
                        <div class="cnt_right">
                            <div>
                                {{ $t('roofManage.monthpower') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ runData && runData.active_power_month | formatMoney }}</i>{{ runData && runData.active_power_month_unit }}
                            </div>
                        </div>
                    </div>
                    <div class="energy_right_cnt_item">
                        <img src="../../../assets/image/custom/elec_year.png" />
                        <div class="cnt_right">
                            <div>
                                {{ $t('roofManage.yearpower') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ runData && runData.active_power_year | formatMoney }}</i>{{ runData && runData.active_power_year_unit }}
                            </div>
                        </div>
                    </div>
                    <div class="energy_right_cnt_item">
                        <img src="../../../assets/image/custom/elec_total.png" />
                        <div class="cnt_right">
                            <div>
                                {{ $t('roofManage.ljpower') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ runData && runData.active_power_total | formatMoney }}</i>{{ runData && runData.active_power_total_unit }}
                            </div>
                        </div>
                    </div>
                    <div class="energy_right_cnt_item">
                        <img src="../../../assets/image/custom/elec_shishi.png" />
                        <div class="cnt_right">
                            <div>
                                {{ $t('roofManage.sspower') }}
                            </div>
                            <div>
                                <i class="linear_font">{{ runData && runData.xnl_total | formatMoney }}</i>%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/radar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar"; 
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import "echarts/lib/component/dataZoom";
import * as api from "@/http/api.js";
import { getDataAll } from "@/http/http-60.js";
import { getCommonInfo } from "../../../http/Use_electricity_monitor";
import dayjs from "dayjs";
export default {
    data() {
        return {
            selectedNbq: {point_id: ''},
            cf_data: [
                {
                    id: '2# Factory',
                    top: 11,
                    left: 1.5,
                    name: this.$t('roofManage.factory2'),
                    num: 17,
                    rotate: 0,
                },
                {
                    id: '1#-1 Factory',
                    top: -2,
                    left: 24.5,
                    name: this.$t('roofManage.factory1_1'),
                    num: 14,
                },
                {
                    id: '1#-2 Factory',
                    top: -11,
                    left: 33.5,
                    name: this.$t('roofManage.factory1_2'),
                    num: 7,
                },
                {
                    id: 'HV Factory',
                    top: 8,
                    left: 50,
                    name: this.$t('roofManage.factoryHV'),
                    num: 9,
                },
                {
                    id: 'IRP-1 Factory',
                    top: -4,
                    left: 58,
                    name: this.$t('roofManage.factoryIRP_1'),
                    num: 5,
                },
                {
                    id: 'IRP-2 Factory',
                    top: 7,
                    left: 88,
                    name: this.$t('roofManage.factoryIRP_2'),
                    num: 2,
                },
                {
                    id: 'Logistics Factory',
                    top: 32,
                    left: 62,
                    name: this.$t('roofManage.factoryLogistics'),
                    num: 9,
                },
                {
                    id: 'MV Factory',
                    top: 28,
                    left: 78,
                    name: this.$t('roofManage.factoryMV'),
                    num: 16,
                }
            ],
            nbq_data: [
                {
                    wd_id: 1,
                    nbq_id: '1693863028199677952',
                    top: 9,
                    left: 15.6,
                    index: 0,
                  //  fault: 1,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863122152087552',
                    top: 10.5,
                    left: 17.6,
                    index: 1,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863226934190080',
                    top: 11.5,
                    left: 19.6,
                    index: 2,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863344668303360',
                    top: 12.5,
                    left: 21.6,
                    index: 3,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863441976156160',
                    top: 13.5,
                    left: 23.9,
                    index: 4,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863533852385280',
                    top: 16,
                    left: 12.8,
                    index: 5,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863616429842432',
                    top: 17.5,
                    left: 15.3,
                    index: 6,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863694930436096',
                    top: 19,
                    left: 17.5,
                    index: 7,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863803328028672',
                    top: 20.5,
                    left: 19.8,
                    index: 8,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693863928150515712',
                    top: 23,
                    left: 9.4,
                    index: 9,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693864014322491392',
                    top: 24.5,
                    left: 11.7,
                    index: 10,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693864092600786944',
                    top: 25.8,
                    left: 14,
                    index: 11,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693864327595057152',
                    top: 27.3,
                    left: 16.2,
                    index: 12,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693864414261960704',
                    top: 29.1,
                    left: 5.6,
                    index: 13,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693864494893260800',
                    top: 30.6,
                    left: 7.9,
                    index: 14,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693864561876295680',
                    top: 31.8,
                    left: 10.2,
                    index: 15,
                },
                {
                    wd_id: 1,
                    nbq_id: '1693864633460482048',
                    top: 32.8,
                    left: 12.6,
                    index: 16,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693824490368294912',
                    top: 19.5,
                    left: 28.1,
                    index: 0,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693824556277587968',
                    top: 20.8,
                    left: 30.5,
                    index: 1,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693824618026131456',
                    top: 22.3,
                    left: 32.8,
                    index: 2,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693824689379631104',
                    top: 23.3,
                    left: 35,
                    index: 3,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693824773425094656',
                    top: 25.7,
                    left: 25,
                    index: 4,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693824840454266880',
                    top: 27.7,
                    left: 27.3,
                    index: 5,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693824915955933184',
                    top: 29.1,
                    left: 29.7,
                    index: 6,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693825000630542336',
                    top: 30.4,
                    left: 31.9,
                    index: 7,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693825072873234432',
                    top: 31.5,
                    left: 21.4,
                    index: 8,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693856672948314112',
                    top: 33.5,
                    left: 23.6,
                    index: 9,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693856780645457920',
                    top: 34.8,
                    left: 26,
                    index: 10,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693856862476328960',
                    top: 36.7,
                    left: 28.2,
                    index: 11,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693856954235117568',
                    top: 37.8,
                    left: 18,
                    index: 12,
                },
                {
                    wd_id: 2,
                    nbq_id: '1693861668821557248',
                    top: 38.9,
                    left: 20.3,
                    index: 13,
                },
                {
                    wd_id: 3,
                    nbq_id: '1693861742616141824',
                    top: -0.7,
                    left: 39.6,
                    index: 0,
                },
                {
                    wd_id: 3,
                    nbq_id: '1693861839445843968',
                    top: 0.7,
                    left: 41.8,
                    index: 1,
                },
                {
                    wd_id: 3,
                    nbq_id: '1693861913148153856',
                    top: 1.7,
                    left: 44.2,
                    index: 2,
                },
                {
                    wd_id: 3,
                    nbq_id: '1693861992684740608',
                    top: 3.5,
                    left: 46.4,
                    index: 3,
                },
                {
                    wd_id: 3,
                    nbq_id: '1693862074398171136',
                    top: 7.1,
                    left: 37.6,
                    index: 4,
                },
                {
                    wd_id: 3,
                    nbq_id: '1693862677392285696',
                    top: 8.1,
                    left: 39.9,
                    index: 5,
                },
                {
                    wd_id: 3,
                    nbq_id: '1693862912181035008',
                    top: 9.4,
                    left: 42.3,
                    index: 6,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693822359456342016',
                    top: 29.7,
                    left: 49.8,
                    index: 0,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693822756468187136',
                    top: 31.7,
                    left: 52.1,
                    index: 1,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693822832129236992',
                    top: 32.4,
                    left: 54.5,
                    index: 2,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693822969731768320',
                    top: 36.4,
                    left: 45.5,
                    index: 3,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693823196048023552',
                    top: 37.2,
                    left: 47.9,
                    index: 4,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693823278776475648',
                    top: 38.5,
                    left: 50.2,
                    index: 5,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693823742263844864',
                    top: 43.5,
                    left: 41.8,
                    index: 6,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693823805576863744',
                    top: 44.5,
                    left: 44.2,
                    index: 7,
                },
                {
                    wd_id: 4,
                    nbq_id: '1693823869519028224',
                    top: 46.5,
                    left: 46.5,
                    index: 8,
                },
                {
                    wd_id: 5,
                    nbq_id: '1693823934220361728',
                    top: 15.5,
                    left: 64.2,
                    index: 0,
                },
                {
                    wd_id: 5,
                    nbq_id: '1693824010963542016',
                    top: 16.5,
                    left: 66.6,
                    index: 1,
                },
                {
                    wd_id: 5,
                    nbq_id: '1693824139334410240',
                    top: 17.6,
                    left: 68.9,
                    index: 2,
                },
                {
                    wd_id: 5,
                    nbq_id: '1693824208964050944',
                    top: 19.4,
                    left: 71.3,
                    index: 3,
                },
                {
                    wd_id: 5,
                    nbq_id: '1693824287674359808',
                    top: 20.5,
                    left: 73.7,
                    index: 4,
                },
                {
                    wd_id: 6,
                    nbq_id: '1693824364518203392',
                    top: 29.8,
                    left: 83.5,
                    index: 0,
                },
                {
                    wd_id: 6,
                    nbq_id: '1693824427814445056',
                    top: 31.7,
                    left: 85.8,
                    index: 1,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693820876627271680',
                    top: 38.4,
                    left: 57.8,
                    index: 0,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693820968042127360',
                    top: 39.9,
                    left: 60.2,
                    index: 1,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693821054532870144',
                    top: 41.2,
                    left: 62.5,
                    index: 2,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693821151983329280',
                    top: 45.2,
                    left: 54.2,
                    index: 3,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693821218119114752',
                    top: 46.2,
                    left: 56.5,
                    index: 4,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693821385857720320',
                    top: 48.1,
                    left: 58.8,
                    index: 5,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693821459853631488',
                    top: 52,
                    left: 50.8,
                    index: 6,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693821910082805760',
                    top: 53,
                    left: 53,
                    index: 7,
                },
                {
                    wd_id: 7,
                    nbq_id: '1693821997496295424',
                    top: 54.6,
                    left: 55.4,
                    index: 8,
                },
                {
                    wd_id: 8,
                    nbq_id: '1689916861174685696',
                    top: 41.2,
                    left: 71.3,
                    index: 0,
                },
                {
                    wd_id: 8,
                    nbq_id: '1689923186587770880',
                    top: 42.7,
                    left: 73.7,
                    index: 1,
                },
                {
                    wd_id: 8,
                    nbq_id: '1689923505094828032',
                    top: 44,
                    left: 76,
                    index: 2,
                },
                {
                    wd_id: 8,
                    nbq_id: '1689923737950003200',
                    top: 46,
                    left: 78.3,
                    index: 3,
                },
                {
                    wd_id: 8,
                    nbq_id: '1689928657193312256',
                    top: 48,
                    left: 68.3,
                    index: 4,
                },
                {
                    wd_id: 8,
                    nbq_id: '1690987658064601088',
                    top: 49,
                    left: 70.6,
                    index: 5,
                },
                {
                    wd_id: 8,
                    nbq_id: '1692463701401161728',
                    top: 51,
                    left: 72.8,
                    index: 6,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693547577536045056',
                    top: 52.4,
                    left: 75,
                    index: 7,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693818337110417408',
                    top: 54.4,
                    left: 64.6,
                    index: 8,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693819058237104128',
                    top: 55.5,
                    left: 66.9,
                    index: 9,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693819228571983872',
                    top: 57.4,
                    left: 69.2,
                    index: 10,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693820170218397696',
                    top: 59,
                    left: 71.5,
                    index: 11,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693820241525760000',
                    top: 61,
                    left: 60.7,
                    index: 12,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693820531901620224',
                    top: 62.5,
                    left: 62.9,
                    index: 13,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693820715893153792',
                    top: 64,
                    left: 65.2,
                    index: 14,
                },
                {
                    wd_id: 8,
                    nbq_id: '1693820797082296320',
                    top: 65,
                    left: 67.4,
                    index: 15,
                },
            ],
            currentCf: null,
            envData: {},
            wsd_x_list: [],
            wsd_series: [],
            wsd_legend: [],
            gz_x_list: [],
            gz_series: [],
            gz_legend: [],
            gz_unit: "",
            runData: {},
            nbqList: [],
            radarData: {},
        };
    },
    async mounted() {
        this.queryEnv();
        this.queryWSD();
        this.queryGZ();
        this.getActivePowerSum('1607650868665954304');
        this.getActivePowerSum('1608279677787443200');
        this.getCommonInfo();
        this.clickCf(this.cf_data[0]);
        this.getFxList();
       // this.setTimer();
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                // if(this.pscItem && this.pscItem.point_id) {
                //     this.getPscList();
                //     this.getBattery();
                // }
            }, 60000);
        },
        goBwgDetail(item) {
            sessionStorage.setItem("activeTab", JSON.stringify({ name:'nbq_power_manage', query:{ point_id: item.point_id, point_60_id: item.point_60_id, bwg_name: item.bwg_name, point_name: item.point_name, position: item.position, model: item.model }}));
            this.$router.push({ name:'nbq_power_manage', query:{ point_id: item.point_id, point_60_id: item.point_60_id, bwg_name: item.bwg_name, point_name: item.point_name, position: item.position, model: item.model } })
        },
        getFxList() {
            api.getFxList().then(res => {
                if (res && res.error_code == 0) {
                   // this.nbqList = res.bus_json;
                   this.radarData = res.bus_json;
                }
            });
        },
        getRoofNbqList(roof_name) {
            api.getRoofNbqList({
                roof: roof_name
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.nbqList = res.bus_json;
                }
            });
        },
        getCommonInfo() {
            getCommonInfo({
                date: dayjs().format('YYYY-MM-DD'),
                point_id: '1694585694388903936',
                point_class_id: '1694583017823166464'
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.envData['ljfzd'] = res.bus_json.active_power_day ? parseFloat(res.bus_json.active_power_day / 1000000).toFixed(2) : '';
                }
            });
        },
        getActivePowerSum(tree_unit_id) {
            api.getActivePowerSum({
                tree_unit_id,
                show_day: dayjs().format('YYYY-MM-DD')
            }).then(res => {
                if (res && res.error_code == 0) {
                    if (res.bus_json == null) return;
                    if (tree_unit_id == "1608279677787443200") {
                        this.runData['active_power_day'] = res.bus_json.active_power_day;
                        this.runData['active_power_month'] = res.bus_json.active_power_month;
                        this.runData['active_power_year'] = res.bus_json.active_power_year;
                        this.runData['active_power_total'] = res.bus_json.active_power_total;
                        this.runData['active_power_day_unit'] = res.bus_json.active_power_day_unit;
                        this.runData['active_power_month_unit'] = res.bus_json.active_power_month_unit;
                        this.runData['active_power_year_unit'] = res.bus_json.active_power_year_unit;
                        this.runData['active_power_total_unit'] = res.bus_json.active_power_total_unit;
                    } else if (tree_unit_id == "1607650868665954304") {
                        this.runData['xnl_total'] = res.bus_json.active_power_total;
                    }
                }
            });
        },
        queryGZ() {
            api.getRealTimeData({
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD'),
                point_id: '1694585694388903936',
                point_class_column_kind_id: '1694583813289697285'
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.gz_x_list= [];
                    res.bus_json.x_list.forEach(item2 =>{this.gz_x_list.push(item2.substring(11, 16))});

                    // 数据
                    this.gz_series = [];
                    // 图例
                    this.gz_legend = [];

                    res.bus_json.y_list.forEach(item => {
                        if(item.column_name == 'zfx') {
                            let everyData = {
                                name: item.column_desc,
                                type: "line",
                                data: item.dataList,
                                itemStyle: {
                                    color: item.column_color
                                },
                                smooth: true,
                                symbol: "none"
                            };
                            this.gz_unit = item.column_unit;
                            this.gz_legend.push(item.column_desc);
                            this.gz_series.push(everyData);
                        }
                    });
                }
            });
        },
        queryWSD() {
            api.getRealTimeData({
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD'),
                point_id: '1694585694388903936',
                point_class_column_kind_id: '1694583813289697281'
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.wsd_x_list= [];
                    res.bus_json.x_list.forEach(item2 =>{this.wsd_x_list.push(item2.substring(11, 16))   });
                    
                    // 数据
                    this.wsd_series = [];
                    // 图例
                    this.wsd_legend = [];

                    res.bus_json.y_list.forEach(item => {
                        if(item.column_name == 'temperature' || item.column_name == 'sd') {
                            let everyData = {
                                name: item.column_desc,
                                type: "line",
                                data: item.dataList,
                                itemStyle: {
                                    color: item.column_color
                                },
                                smooth: true,
                                symbol: "none",
                                unit: item.column_unit,
                            };
                            this.wsd_legend.push(item.column_desc);
                            this.wsd_series.push(everyData);
                        }
                    });
                }
            });
        },
        queryEnv() {
            let pointIds=['1694585694388903936'];
            getDataAll(pointIds).then(res => {
                if (undefined !== res.bus_json) {
                    let valueJson = res.bus_json;
                    let point = valueJson['1694585694388903936'];
                    this.envData['fs'] = point && point.fs;
                    if(point && parseInt(point.fx) == 0) this.envData['fx'] = this.$t('roofManage.north');
                    else if(point && parseInt(point.fx) == 45) this.envData['fx'] = this.$t('roofManage.northeast');
                    else if(point && parseInt(point.fx) == 90) this.envData['fx'] = this.$t('roofManage.east');
                    else if(point && parseInt(point.fx) == 135) this.envData['fx'] = this.$t('roofManage.southeast');
                    else if(point && parseInt(point.fx) == 180) this.envData['fx'] = this.$t('roofManage.south');
                    else if(point && parseInt(point.fx) == 225) this.envData['fx'] = this.$t('roofManage.southwest');
                    else if(point && parseInt(point.fx) == 270) this.envData['fx'] = this.$t('roofManage.west');
                    else if(point && parseInt(point.fx) == 315) this.envData['fx'] = this.$t('roofManage.northwest');
                    this.envData['temperature'] = point && point.temperature;
                    this.envData['zfx'] = point && point.zfx ? parseFloat(point.zfx * 3.6 / 1000).toFixed(2) : '';
                    this.envData['sd'] = point && point.sd;
                    this.$forceUpdate();
                }
            });
        },
        toggleColorTop(item, shown) {
            if(shown) this.selectedNbq = {nbq_id: item.point_id};
            else this.selectedNbq = {nbq_id: ''};
        },
        toggleColor(item, shown) {
            let htmlFontSize = document.documentElement.style.fontSize.replace('px',''); // html的font-seze的值
            this.$nextTick(() => {
                this.$refs.scrollNbq.scrollTo({top: htmlFontSize * Math.floor(item.index / 6) * 4.2, behavior: 'smooth'})
            })
            if(shown) this.selectedNbq = item;
            else this.selectedNbq = {nbq_id: ''};
        },
        changePSC(item) {
            this.pscItem = item;
            if(this.pscItem && this.pscItem.point_id) this.getBattery();
        },
        clickCf(item) {
            this.currentCf = item;
            this.getRoofNbqList(item.id);
        }
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
        areaLine() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    }
                },
                grid: {
                    left: "5%",
                    right: "6%",
                    top: "20%",
                    bottom: "5%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                    axisLabel: {
                            //x轴文字的配置
                            show: true,
                        textStyle: {
                                color: "#999999"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                                color: "#0c576d" // 颜色
                        }
                    },
                        data: this.gz_x_list
                    }
                ],
                yAxis: [
                    {
                        name: this.gz_unit,
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#999999" // 颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        nameTextStyle: {
                            color: "#999999",
                            //    padding: 10,
                            fontSize: 10
                        },
                         splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.gz_series.length && this.gz_series[0].name,
                        type: "line",
                        // name: this.quxian.legendData[0],
                        label: {
                            normal: {
                                show: false,
                                position: "top"
                            }
                        },
                        smooth: true,
                        symbolSize: 0.1,
                        itemStyle: {
                            normal: {
                                color: 'rgba(44, 119, 182, 1)',
                                shadowBlur: 8,
                                shadowColor: '#25d5f0',
                                borderColor: '#00c1de',
                                borderWidth: 2,
                                backgroundColor: 'transparent'
                            }
                        },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(37, 80, 117, 1)'
                            }, {
                                offset: 1,
                                color: 'rgba(4, 39, 51, 0.19)'
                            }]),
                        }
                    },
                        data: this.gz_series.length && this.gz_series[0].data
                    }
                ]
            };
            return option;
        },
        centerBar() {
            const option = {
                grid: {
                    left: "1%",
                    right: "3%",
                    bottom: "4%",
                    top: "20%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: this.wsd_x_list,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: this.wsd_series.length> 0 ? this.wsd_series[0].unit : '',
                        type: "value",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    },
                    {
                        name: this.wsd_series.length> 0 ? this.wsd_series[1].unit : '',
                        type: "value",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.wsd_series.length> 0 ? this.wsd_series[0].name : '',
                        type: "line",
                        barWidth: '35%',
                        itemStyle: {
                            normal: {
                                // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                //     offset: 0,
                                //     color: 'rgba(33, 178, 251, 1)'
                                // }, {
                                //     offset: 1,
                                //     color: 'rgba(24, 47, 76, 1)'
                                // }]),
                               // barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        barGap: 0,
                        data: this.wsd_series.length> 0 ? this.wsd_series[0].data : [],
                    },
                    {
                        name: this.wsd_series.length> 1 ? this.wsd_series[1].name : '',
                        type: 'line',
                        yAxisIndex: 1,
                        itemStyle: {  /*设置折线颜色*/
                            normal: {
                                color: 'rgba(8, 164, 97, 1)'
                            }
                        },
                        // areaStyle: {
                        //     normal: {
                        //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        //             offset: 0,
                        //             color: 'rgba(4, 181, 107, 1)'
                        //         }, {
                        //             offset: 1,
                        //             color: 'rgba(7, 124, 84, 0)'
                        //         }]),
                        //     }
                        // },
                        data: this.wsd_series.length> 1 ? this.wsd_series[1].data : [],
                    }
                ]
            };
            return option;
        },
        fengsuRadar() {
            const option = {
                tooltip: {
                    trigger: 'axis'
                },
                textStyle: {
                    fontSize: 10,
                    lineHeight: 10,
                    color: '#ccc'
                },
                radar: [
                    {
                        indicator: this.radarData && this.radarData.name_list,
                        center: ['50%', '50%'],
                        radius: '53%',
                        splitLine: {
                            lineStyle: {
                                color: [
                                    'rgba(13, 122, 255, 0.1)',
                                    'rgba(13, 122, 255, 0.4)',
                                    'rgba(13, 122, 255, 0.6)',
                                    'rgba(13, 122, 255, 0.8)',
                                    'rgba(13, 122, 255, 1)'
                                ].reverse()
                            }
                        },
                        splitArea: {
                            areaStyle: {
                                color: ['transparent', 'transparent', 'transparent', 'transparent'],
                                shadowColor: 'rgba(0, 0, 0, 0.1)',
                                shadowBlur: 10
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(13, 122, 255, 0.5)'
                            }
                        }
                    },
                ],
                series: [
                    {
                        type: 'radar',
                        tooltip: {
                            trigger: 'item'
                        },
                        areaStyle: {},
                        symbol: 'none',
                        data: [
                            {
                                value: this.radarData && this.radarData.rate_list,//[60, 73, 85, 40, 56, 57,58, 58],
                                name: '风速风向',
                                lineStyle: {
                                  //  type: 'dashed',
                                    color: 'rgba(13, 122, 255, 1)'
                                },
                                areaStyle: {
                                    color: 'rgba(13, 122, 255, 0.6)'
                                }
                            }
                        ]
                    }
                ]
            };
            return option;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.stored_energy_manage {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 2rem;
    //border: 1px solid red;
    // background: url("../../../assets/image/custom/elec_battery_back.png") no-repeat left 100%;
    // background-size: 60% auto;
    position: relative;
    display: inline-flex;
    color: #fff;
    i {
        font-size: 1rem;
        &::after {
            content: ' ';
            white-space: pre;
        }
    }
    .energy_left {
        width: 25%;
        height: 100%;
        display: inline-flex;
        flex-flow: column;
        justify-content: space-between;
        .energy_left_div {
            width: 100%;
            height: 23.5%;
            background: url("../../../assets/image/custom/energy_short_rect.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .energy_left_title {
                position: absolute;
                top: 7%;
                left: 12%;
                font-size: 0.9rem;
            }
            .energy_left_cnt {
                width: 94%;
                height: 80%;
                position: absolute;
                top: 20%;
                left: 3%;
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                flex-flow: row wrap;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
                .energy_left_cnt_item {
                    width: 32%;
                    height: 38%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: space-between;
                    img {
                        width: 30%;
                    }
                    .left_cnt_right {
                        width: 68%;
                        height: 100%;
                        margin-left: 2%;
                       // border: 1px solid red;
                        // display: inline-flex;
                        // flex-flow: column;
                        // justify-content: space-between;
                        div {
                            width: 100%;
                            height: 50%;
                            display: flex;
                            align-items: center;
                           // justify-content: center;
                            font-size: 0.75rem;
                        }
                    }
                }
            }
        }
    }
    .energy_right {
        width: 73%;
        height: 100%;
        margin-left: 2%;
        display: inline-flex;
        flex-flow: column;
        justify-content: space-between;
        .energy_right_top_div {
            width: 100%;
            height: 24%;
            background: url("../../../assets/image/custom/elec_energy_right_top.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .energy_right_top_title {
                position: absolute;
                top: 0;
                left: 0.5rem;
                width: 100%;
                height: 1.2rem;
                display: inline-flex;
                align-items: center;
                div {
                    font-size: 0.75rem;
                    margin-left: 0.3rem;
                }
            }
            .energy_right_top_cnt {
                width: 98%;
                height: calc(100% - 1.5rem);
                display: inline-flex;
                flex-flow: row wrap;
                box-sizing: border-box;
             //   margin: 0 2%;
               // align-items: center;
              //  justify-content: space-between;
                //padding: 0.5rem 1rem;
               // border: 1px solid red;
                margin: 1.5rem 1% 0;
                position: relative;
                overflow-y: auto;
                .top_cnt_item_wrapper {
                    width: 100%; height: 100%; display: inline-flex; align-items: self-start;flex-flow: row wrap;
                }
                .top_cnt_item_detail {
                    position: absolute;
                    top: 97%;
                    left: 45%;
                    border: 1px solid rgb(196, 14, 14);
                    width: 6rem;
                    height: 3rem;
                    padding: 0 0.2rem;
                    box-sizing: border-box;
                    div {
                        height: 1rem;
                        line-height: 1rem;
                        font-size: 0.6rem;
                        color: #fff;
                    }
                }
                .blue_rec {
                    border: 1px solid rgba(13, 122, 255, 1);
                    box-shadow: 0 0 0.4rem rgba(13, 122, 255, 1);
                }
                .red_rec {
                    border: 1px solid;
                    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(227, 46, 44, 1) 50%, rgb(138, 4, 2) 99%) 1 1 1 1; 
                }
                .grey_rec {
                    border: 1px solid;
                    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(24, 93, 178, 1) 50%, rgba(24, 93, 178, 1) 99%) 1 1 1 1; 
                }
                .top_cnt_item {
                    width: 15%;
                    height: 3.6rem;
                  //  margin-top: 0.4rem;
                  //  margin: 0.5% 0.5% 0 0.5%;
                  //  border: 1px solid red;
                    box-sizing: border-box;
                    margin: 0.3rem 0.83%;
                    font-size: 0.7rem;
                    .top_cnt_title {
                        width: 100%;
                        height: 1.4rem;
                      //  border: 1px solid red;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .top_cnt_cnt {
                        width: 100%;
                        height: 2rem;
                        display: inline-flex;
                        flex-flow: row wrap;
                        .top_cnt_cnt_item {
                            width:24.4%;
                            margin: 0 0.3%;
                            height: 1rem;
                            text-align: center;
                            line-height: 1rem;
                        }
                        .blue_lit_rec {
                            background: url("../../../assets/image/custom/energy_lit_rec_blue.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        .red_lit_rec {
                            background: url("../../../assets/image/custom/energy_lit_rec_red.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        .grey_lit_rec {
                            background: url("../../../assets/image/custom/energy_lit_rec_grey.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
        }
        .energy_right_title {
            position: absolute;
            top: 7%;
            left: 5%;
            font-size: 0.9rem;
            background: linear-gradient(to bottom, #fff 60%, rgba(109, 191, 255, 1) 90%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .energy_right_center_div {
            width: 100%;
            height: 48%;
           // border: 1px solid red;
            display: inline-flex;
            align-items: flex-end;
            justify-content: center;
            .center_pic_div {
                height: 87%; 
                width: fit-content;
                position: relative;
                img {
                    height: 100%;
                    width: auto;
                }
                .center_pic_name_selected {
                    background: url("../../../assets/image/custom/energy_center_green.png") no-repeat;
                    background-size: 100% 100%;
                }
                .center_pic_name_unselected {
                    background: url("../../../assets/image/custom/energy_center_blue.png") no-repeat;
                    background-size: 100% 100%;
                }
                .center_pic_name {
                    position: absolute;
                    width: 4rem;
                    height: 5rem;
                    cursor: pointer;
                    .center_pic_name_detail {
                        position: absolute;
                        top: 0.3rem;
                        left: 0.2rem;
                        font-size: 0.7rem;
                        width: 6rem;
                    }
                    .center_pic_name_nbq {
                        width: 6rem;
                        position: absolute;
                        top: -1.3rem;
                        left: 0;
                        font-size: 0.8rem;
                    }
                }
                .center_nbq {
                    position: absolute;
                    width: 1.5rem;
                    height: 1.7rem;
                    z-index: 2;
                    .nbq_fault {
                        width: 4rem;
                        height: 1.2rem;
                        background: url("../../../assets/image/custom/energy_nbq_fault.png") no-repeat;
                        background-size: 100% 100%;
                        text-indent: 1.2rem;
                        line-height: 1.2rem;
                        position: absolute;
                        top: -1.2rem;
                        left: 0;
                        font-size: 0.6rem;
                    }
                }
                .center_nbq_blue {
                    width: 100%;
                    height: 100%;
                    background: url("../../../assets/image/custom/nbq_blue.png") no-repeat;
                    background-size: 100% 100%;
                }
                .center_nbq_red {
                    width: 100%;
                    height: 100%;
                    background: url("../../../assets/image/custom/nbq_red.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
        .energy_right_bottom_div {
            width: 100%;
            height: 24%;
            background: url("../../../assets/image/custom/elec_energy_long_rect.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
        }
        .energy_right_bottom_cnt {
            width: 100%;
            height: 80%;
            position: absolute;
            top: 20%;
            left: 0;
            display: inline-flex;
            align-items: center;
            justify-content: space-evenly;
            flex-flow: row nowrap;
            .energy_right_cnt_item {
                width: 15%;
                height: 45%;
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                img {
                    width: 30%;
                }
                .cnt_right {
                    width: 68%;
                    height: 100%;
                    margin-left: 2%;
                    // border: 1px solid red;
                    // display: inline-flex;
                    // flex-flow: column;
                    // justify-content: space-between;
                    div {
                        width: 100%;
                        height: 50%;
                        display: flex;
                        align-items: center;
                        // justify-content: center;
                        font-size: 0.75rem;
                    }
                }
            }
        }
    }
}
</style>
